import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Router } from '@angular/router'

import { ToastrService } from 'ngx-toastr'
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'

import { environment } from 'src/environments/environment'
import { Mensagem } from 'src/app/models/mensagem.model'

import { LoginService } from 'src/app/shared/login.service'
import { MensagemService } from './mensagens.service'
import { Subscription } from 'rxjs'

const msgID = environment.message.id

@Component({
	selector: 'app-mensagens',
	templateUrl: './mensagens.component.html',
	styleUrls: ['./mensagens.component.scss'],
})
export class MensagensComponent implements OnInit, OnDestroy {
	title = 'Mensagem'

	mensagem: Mensagem = new Mensagem()
	updateMessageForm: FormGroup
	modalRef: NgbModalRef
	closeResult: string
	loginDisplay = false

	private subscriptions: Subscription[] = []

	constructor(
		private mensagemService: MensagemService,
		private modalService: NgbModal,
		private toastrService: ToastrService,
		private router: Router,
		private loginService: LoginService
	) {}

	ngOnInit() {
		this.subscriptions.push(
			this.loginService.user$.subscribe((user) => {
				this.loginDisplay = !!user
			})
		)

		this.getMensagemPorID(msgID)
	}

	getMensagemPorID(msgID: string) {
		this.mensagemService.getMensagemPorID(msgID).subscribe((res) => {
			if (res.status >= 400) {
				this.showAlertInfo(res.statusText)
			} else {
				this.mensagem = res.mensagem
			}
		})
	}

	onUpdate(content) {
		let mensagem = JSON.parse(JSON.stringify(content))
		this.mensagemService.update(mensagem).subscribe(
			(res) => {
				if (res) {
					this.showSucessUpdate('Registro atualizado com sucesso.')
				}
			},
			(error) => {
				let erro: number = error | error.messsage
				this.showErrorUpdate(erro)
			}
		)
	}

	open(form) {
		this.modalRef = this.modalService.open(form)
		this.modalRef.result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`
			}
		)
	}

	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'Pressione ESC para sair'
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'Click OK para executar a tarefa'
		} else {
			return `with: ${reason}`
		}
	}

	showSucessUpdate(msg) {
		this.toastrService.success(msg, 'PTA - Portal de Transferência de Arquivos')
		this.router.navigateByUrl('/mensagens')
	}

	showErrorUpdate(msg) {
		this.toastrService.error(msg, 'PTA - Portal de Transferência de Arquivos')
		this.router.navigateByUrl('/mensagens')
	}

	showAlertInfo(msg) {
		this.toastrService.error(`${msg} - Ocorreu um erro ao fazer a chamada, por favor tente mais tarde!`, 'PTA - Portal de Transferência de Arquivos')
		this.router.navigateByUrl('/mensagens')
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe())
	}
}
